export default "__VITE_ASSET__GVmTkQ2l__"